import { combineReducers, configureStore } from '@reduxjs/toolkit';
import userSlicer from './slicers/user';
import activityReducer from './slicers/activitySlicer';
import sessionReducer from './slicers/sessionSlicer';
import loginReducer from './slicers/login/loginSlicer';
import sampleReducer from './slicers/login/sampleSlicer';
import curatorSlicer from './slicers/admin/curatorSlicer';
import searchReducer from './slicers/search/searchSlicer';
import settingsReducer from './slicers/admin/settingsSlicer';
import trashReducer from './slicers/trash/trashSlicer';
import sharedFilesReducer from './slicers/shared-files/sharedFilesSlicer';
import myprojectsReducer from './slicers/my-projects/myProjectsSlicer';
import teamReducer from './slicers/team/teamSlicer';
import sidebarReducer from './slicers/admin/sidebarSlicer';
import propsReducer from './slicers/admin/propsSlicer';
import roomsReducer from './slicers/admin/roomsSlicer';
import materialReducer from './slicers/materials/materialsSlicer';
import textureReducer from './slicers/textures/textureSlicer';
import cameraAngleReducer from './slicers/camera/cameraAngleSlicer';
import rendersPreviewsExpReducer from './slicers/renders-previews/rendersPreviewsSlicer';
import projectCameraAngleReducer from './slicers/camera/projectCameraAngleSlicer';
import myRenderPreviewReducer from './slicers/render_preview/myRenderPreviewSlice';
import myRenderDownloadReducer from './slicers/render_preview/myRenderDownloadSlice';
import utilitiesReducer from './slicers/utilities/utilitiesSlicer';
import cameraSettingsReducer from './slicers/camera/cameraSettings';
import filterReducer from './slicers/filters/filterSlicer';
import organisationReducer from './slicers/organisation/organisationSlicer';
import tagReducer from './slicers/tags/globalTagSlicer';
import curatorStylesReducer from './slicers/admin/curatorStylesSlicer';
import infoDialogReducer from './slicers/infoDialogSlicer';
import myProjectDetailsReducer from './slicers/myProjectDetails/myProjectDetailsSlicer';
import paginatedTeamReducer from './slicers/team/paginatedTeamSlicer';
import uiReducer from './slicers/uiSlicer';
import uploadsReducer from './slicers/uploads/uploadSlicer';
import paginatedMaterialsReducer from './slicers/materials/paginatedMaterialSlicer';
import paginatedTexturesReducer from './slicers/textures/paginatedTexturesSlicer';
import curatorLightReducer from './slicers/admin/curatorLightSlicer';
import curatorMetadataReducer from './slicers/admin/curatorMetadataSlicer';
import curatorAutomationReducer from './slicers/admin/curatorAutomationSlicer';
import paginatedLightReducer from './slicers/admin/paginatedLightSlicer';
import paginatedColorReducer from './slicers/admin/paginatedColorSlicer';
import curatorUnityObjectReducer from './slicers/admin/curatorUnityObjectSlicer';
import paginatedProductReducer from './slicers/admin/paginatedProductSlicer';
import curatorProductReducer from './slicers/admin/curatorProductSlicer';
import paginatedRenderPreviewsReducer from './slicers/admin/paginatedRenderPreviewsSlicer';
import curatorMenuPreferencesReducer from './slicers/admin/curatorMenuPreferencesSlicer';
import renderPreviewPoppupReducer from './slicers/camera/renderPreviewPoppupSlicer';
import shortcutsModuleReducer from './slicers/admin/shortcutsModuleSlicer';
import curatorProjectArchiveReducer from './slicers/admin/curatorProjectArchiveSlicer';
import curatorLoaderReducer from './slicers/admin/curatorLoaderSlicer';
import cameraEditReducer from './slicers/camera/cameraEditSlicer';
import curatorLayoutReducer from './slicers/admin/curatorLayoutSlicer';
import transactionHistoryReducer from './slicers/transactionHistorySicer';
import searchMembersReducer from './slicers/searchMembersSlicer';
import transactionHistoryEmailListReducer from './slicers/transactionHistoryEmailListSlicer';
import collectionListReducer from './slicers/collectionListSlicer';
import appConfigReducer from './slicers/appConfigSlicer';
import profilePreferencesReducer from './slicers/profilePreferencesSlicer';
import collectionsReducer from './slicers/collectionsSlicer';
import paginatedRoomsReducer from './slicers/admin/paginatedRooms';
import texturesReducer from './slicers/texturesSlicer';
import collectionItemsReducer from './slicers/collectionItemsSlicer';
import uploadsPageReducer from './slicers/uploadsPageSlicer';
import sharedFilesPageReducer from './slicers/sharedFilesPageSlicer';
import sharePopupReducer from './slicers/sharePopupSlicer';
import addToCollectionReducer from './slicers/addToCollectionPopupSlicer';
import textureDetailsModalReducer from './slicers/textureDetailsModalSlicer';
import propDetailsPopupReducer from './slicers/propDetailsPopupSlicer';
import editPropDetailsPopupReducer from './slicers/editPropDetailsPopupSlicer';
import editRoomDetailsPopupReducer from './slicers/editRoomDetailsPopupSlicer';
import model3dDetailsReducer from './slicers/model3dDetailsSlicer';
import curatorProductsReducer from './slicers/admin/curatorProductsSlicer';
import globalRenderingInfoReducer from './slicers/globalRenderingInfoSlicer';
import curatorExclusivePropsReducer from './slicers/admin/curatorExclusivePropSlicer';
import ticketsReducer from './slicers/ticketSlicer';
import createTicketModalReducer from './slicers/createTicketModalSlicer';
import curatorMissingDataReducer from './slicers/admin/curatorMissingDataSlicer';
import { undoRedoReducer } from './slicers/admin/undoRedoSlicer';
import { curatorSnappingReducer } from './slicers/admin/curatorSnappingSlicer';
import { curatorLoadingProgressBarReducer } from './slicers/admin/curatorLoadingProgressBarSlicer';
import { curatorDebuggerReducer } from './slicers/admin/curatorDebuggerSlicer';
import curatorBackupReducer from './slicers/admin/curatorBackupSlicer';
import appReducer from './slicers/appSlicer';
import curatorTextureUploadFailedDialogReducer from './slicers/admin/curatorTextureUploadFailedDialogSlicer';
import paginatedAutomationReducer from './slicers/admin/paginatedAutomation';
import paginatedAutomationDetailsReducer from './slicers/automation/paginatedAutomationDetails';
import { paginatedAutomationExcelListReducer } from './slicers/automation/paginatedAutomationExcelList';
import productConfiguratorsReducer from './slicers/productConfiguratorsSlicer';
import configuratorReducer from './slicers/configurator/configurator.slicer';
import configuratorUnityObjectReducer from './slicers/configurator/configuratorUnityObject.slicer';
import { configuratorColorDialogReducer } from './slicers/configurator/configuratorColorDialog.slicer';
import { configuratorLabelDetailsReducer } from './slicers/configurator/configuratorLabelDetails.slicer';
import configuratorUnityObjectPropertiesReducer from './slicers/configurator/configuratorUnityObjectProperties.slicer';
import { configuratorSceneProductsReducer } from './slicers/configurator/configuratorSceneProducts.slicer';
import configuratorCameraReducer from './slicers/configurator/configuratorCamera.slicer';
import { configuratorSceneViewsReducer } from './slicers/configurator/configuratorViews.slicer';
import { configuratorSceneLabelsReducer } from './slicers/configurator/configuratorSceneLabels.slicer';
import configuratorLightingReducer from './slicers/configurator/configuratorLighting.slicer';
import { configuratorViewBackgroundReducer } from './slicers/configurator/configuratorViewBackground.slicer';
import { configuratorPreviewReducer } from './slicers/configurator/configuratorPreview.slicer';
import { configuratorOptionDetailsReducer } from './slicers/configurator/configuratorOptionDetails.slicer';
import learnByVideoReducer from './slicers/learnByVideoSlicer';
import onBoardingReducer from './slicers/onBoardingSlicer';
import imagePaymentFormPopupReducer from './slicers/imagePaymentFormPopupSlicer';
import paginatedConfiguratorsReducer from './slicers/admin/paginatedConfigurators';
import gamificationTooltipReducer from './slicers/gamificationTooltipSlicer';
import gamifyBoardingReducer from './slicers/gamifySlicer';
import subscriptionReducer from './slicers/subscriptionSlicer';
import paginatedRequestsReducer from './slicers/admin/paginatedRequests';
import paginatedSharedProductPageReducer from './slicers/admin/paginatedSharedProduct';
import requestsReducer from './slicers/requestSlicer';
import bulkTextureUploadReducer from './slicers/bulkTextureUpload';
import curatorTileGroutReducer from './slicers/admin/curatorTileGroutSlicer';
import paginatedAttachmentsReducer from './slicers/admin/paginatedAttachements';
import configuratorLightingPopupReducer from './slicers/configurator/configuratorLightingPopup.slicer';
import measureToolReducer from './slicers/measureToolSlicer';
import upload3DModelProductReducer from './slicers/upload3DModelProductSlicer';
import retailAutomationListReducer from './slicers/retailAutomationListSlicer';
import retailAutomationReducer from './slicers/retailAutomation/retailAutomation.slicer';
import paginatedImagineAIReducer from './slicers/admin/paginatedImagineAI';
import productBuilderListReducer from './slicers/productBuilderListSlicer';
import productBuilderReducer from './slicers/productBuilder/productBuilder.slicer';
import productPageV2Reducer from './slicers/productV2Slicer';
import dashboardTabMaterialsReducer from './slicers/dashboardTabMaterialSlicer';
import productSetupReducer from './slicers/productSetup/productSetup.slicer';
import retailConfiguratorReducer from './slicers/retailConfiguratorSlicer';

const rootReducer = combineReducers({
  app: appReducer,
  user: userSlicer,
  activity: activityReducer,
  session: sessionReducer,
  login: loginReducer,
  sample: sampleReducer,
  curator: curatorSlicer,
  curatorLoader: curatorLoaderReducer,
  curatorStyles: curatorStylesReducer,
  curatorLight: curatorLightReducer,
  curatorUnityObject: curatorUnityObjectReducer,
  paginatedLight: paginatedLightReducer,
  paginatedProduct: paginatedProductReducer,
  paginatedRenderPreviews: paginatedRenderPreviewsReducer,
  curatorMetadata: curatorMetadataReducer,
  curatorAutomation: curatorAutomationReducer,
  transactionHistory: transactionHistoryReducer,
  transactionHistoryEmailList: transactionHistoryEmailListReducer,
  curatorProduct: curatorProductReducer,
  curatorLayout: curatorLayoutReducer,
  curatorProducts: curatorProductsReducer,
  curatorProjectArchive: curatorProjectArchiveReducer,
  curatorMissingData: curatorMissingDataReducer,
  curatorTextureUploadFailedDialog: curatorTextureUploadFailedDialogReducer,
  curatorSnapping: curatorSnappingReducer,
  curatorLoadingProgressBar: curatorLoadingProgressBarReducer,
  curatorBackup: curatorBackupReducer,
  curatorDebugger: curatorDebuggerReducer,
  undoRedo: undoRedoReducer,
  search: searchReducer,
  renderPreviewPoppup: renderPreviewPoppupReducer,
  settings: settingsReducer,
  model3dDetails: model3dDetailsReducer,
  trash: trashReducer,
  globalRenderingInfo: globalRenderingInfoReducer,
  curatorExclusiveProps: curatorExclusivePropsReducer,
  sharePopup: sharePopupReducer,
  sharedFiles: sharedFilesReducer,
  sharedFilesPage: sharedFilesPageReducer,
  addToCollection: addToCollectionReducer,
  textureDetailsModal: textureDetailsModalReducer,
  propDetailsPopup: propDetailsPopupReducer,
  editPropDetailsPopup: editPropDetailsPopupReducer,
  upload3DModelProduct: upload3DModelProductReducer,
  editRoomDetailsPopup: editRoomDetailsPopupReducer,
  myprojects: myprojectsReducer,
  myProjectDetails: myProjectDetailsReducer,
  productConfigurators: productConfiguratorsReducer,
  team: teamReducer,
  searchMembers: searchMembersReducer,
  collectionList: collectionListReducer,
  collections: collectionsReducer,
  collectionItems: collectionItemsReducer,
  paginatedRooms: paginatedRoomsReducer,
  paginatedTeam: paginatedTeamReducer,
  sidebar: sidebarReducer,
  props: propsReducer,
  shortcutsModule: shortcutsModuleReducer,
  rooms: roomsReducer,
  profilePreferences: profilePreferencesReducer,
  material: materialReducer,
  paginatedMaterials: paginatedMaterialsReducer,
  configurator: configuratorReducer,
  configuratorUnityObject: configuratorUnityObjectReducer,
  configuratorUnityObjectProperties: configuratorUnityObjectPropertiesReducer,
  configuratorColorDialog: configuratorColorDialogReducer,
  configuratorLabelDetails: configuratorLabelDetailsReducer,
  configuratorSceneProducts: configuratorSceneProductsReducer,
  configuratorSceneViews: configuratorSceneViewsReducer,
  configuratorSceneLabels: configuratorSceneLabelsReducer,
  configuratorPreview: configuratorPreviewReducer,
  configuratorCamera: configuratorCameraReducer,
  configuratorLighting: configuratorLightingReducer,
  configuratorViewBackground: configuratorViewBackgroundReducer,
  configuratorOptionDetails: configuratorOptionDetailsReducer,
  texture: textureReducer,
  paginatedTextures: paginatedTexturesReducer,
  textures: texturesReducer,
  uploadsPage: uploadsPageReducer,
  paginatedColor: paginatedColorReducer,
  cameraAngle: cameraAngleReducer,
  cameraEdit: cameraEditReducer,
  myRenderPreview: myRenderPreviewReducer,
  myRenderDownload: myRenderDownloadReducer,
  rendersPreviewsExp: rendersPreviewsExpReducer,
  projectCameraAngle: projectCameraAngleReducer,
  filter: filterReducer,
  organisation: organisationReducer,
  tag: tagReducer,
  utilities: utilitiesReducer,
  curatorMenuPreferences: curatorMenuPreferencesReducer,
  cameraSettings: cameraSettingsReducer,
  infoDialog: infoDialogReducer,
  ui: uiReducer,
  uploads: uploadsReducer,
  appConfig: appConfigReducer,
  tickets: ticketsReducer,
  createTicketModal: createTicketModalReducer,
  paginatedAutomation: paginatedAutomationReducer,
  paginatedAutomationDetails: paginatedAutomationDetailsReducer,
  paginatedAutomationExcelList: paginatedAutomationExcelListReducer,
  onBoarding: onBoardingReducer,
  learnByVideo: learnByVideoReducer,
  imagePaymentFormPopup: imagePaymentFormPopupReducer,
  paginatedConfigurators: paginatedConfiguratorsReducer,
  gamifyBoarding: gamifyBoardingReducer,
  gamificationTooltip: gamificationTooltipReducer,
  subscription: subscriptionReducer,
  paginatedRequests: paginatedRequestsReducer,
  paginatedSharedProductPage: paginatedSharedProductPageReducer,
  requests: requestsReducer,
  paginatedRequestAttachments: paginatedAttachmentsReducer,
  bulkTextureUpload: bulkTextureUploadReducer,
  curatorTileGrout: curatorTileGroutReducer,
  configuratorLightingPopup: configuratorLightingPopupReducer,
  measureTool: measureToolReducer,
  retailAutomationList: retailAutomationListReducer,
  retailAutomation: retailAutomationReducer,
  imagineAIImages: paginatedImagineAIReducer,
  productBuilderList: productBuilderListReducer,
  productBuilder: productBuilderReducer,
  productPageV2: productPageV2Reducer,
  dashboardTabMaterials: dashboardTabMaterialsReducer,
  productSetup: productSetupReducer,
  retailConfigurator: retailConfiguratorReducer,
});

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          'curator/setImageScanSearchFile',
          'infoDialog/openInfoDialog',
          'curatorProjectArchive/setFile',
          'paginatedTextures/setAdditionalData',
          'gamificationTooltip/setData',
          'configurator/setObjectsWithDefaultThumbnail',
          'retailAutomation/setAutomationSets',
          'app/updateFile',
          'app/addFiles',
          'app/setUploadedFiles',
          'paginatedRenderPreviews/setCollectionList',
        ],
        // Ignore these paths in the state
        ignoredPaths: [
          'curator',
          'infoDialog',
          'curatorProjectArchive',
          'curatorTextureUploadFailedDialog',
          'paginatedTextures',
          'gamificationTooltip',
          'configurator',
          'retailAutomation',
          'app.uploadedFiles',
          'paginatedRenderPreviews.collectionDataList',
        ],
      },
    }),
});
export default store;

export const getStore = () => store;
export const getAppState = () => store.getState();
